<template>
  <v-container fluid>
    <canvas id="matrix"></canvas>
    <v-row>
      <v-col cols="12" align="center" class="name">George Kampitakis</v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="center" class="title"
        >Software Engineer</v-col
      >
    </v-row>
    <v-row>
      <v-col cols="12" align="center">
        <media-buttons />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mediaButtons from './media-buttons';
import { mapGetters } from 'vuex';

export default {
  name: 'home',
  components: {
    mediaButtons
  },
  computed: {
    ...mapGetters(['jsonData'])
  },
  mounted() {
    this.setBackGround();
  },
  methods: {
    setBackGround: () => {
      const canvas = document.getElementById('matrix'),
        canvasContext = canvas.getContext('2d'),
        characters = 'qwertyuiopasdfghjkl1234567890zxcvbnm',
        font_size = 10,
        drops = [];

      canvas.height = window.innerHeight;
      canvas.width = window.innerWidth;

      const columns = canvas.width / font_size;

      for (let x = 0; x < columns; x++) drops[x] = 1;

      function draw() {
        canvasContext.fillStyle = 'rgba(0, 0, 0, 0.05)';
        canvasContext.fillRect(0, 0, canvas.width, canvas.height);

        canvasContext.fillStyle = '#0F0';
        canvasContext.font = font_size + 'px arial';
        //looping over drops
        for (let i = 0; i < drops.length; i++) {
          const text =
            characters[Math.floor(Math.random() * characters.length)];

          canvasContext.fillText(text, i * font_size, drops[i] * font_size);

          if (drops[i] * font_size > canvas.height && Math.random() > 0.975)
            drops[i] = 0;

          //incrementing Y coordinate
          drops[i]++;
        }
      }

      setInterval(draw, 33);
    }
  }
};
</script>

<style scoped>
.loader {
  color: #009b64ba;
  margin-top: 20vh;
}

.row {
  position: relative;
}

.here {
  color: purple;
}

a {
  text-decoration: none;
  color: white;
}

.footer {
  position: absolute;
  bottom: 20px;
  width: 100%;
  font-size: 20px;
}

canvas {
  display: block;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: absolute;
  font-size: 10px;
}

.container {
  margin-top: 20vh;
}

.name {
  font-size: 96px;
}

.title {
  font-size: 46px;
}

@media only screen and (min-device-height: 300px) and (max-device-height: 600px) and (orientation: landscape) {
  .container {
    margin-top: 5vh;
  }

  .name {
    font-size: 46px;
  }

  .title {
    font-size: 20px;
  }
}

@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  .container {
    margin-top: 5vh;
  }

  .name {
    font-size: 46px;
  }

  .title {
    font-size: 20px;
  }
}
</style>
